/**
 * @file Ticks timed buffs and shields (GDD §Fase 3 — powerups).
 *
 * Runs before the controllers so a buff that expires this frame is already gone
 * by the time movement or combat read their multipliers.
 */

import { System } from '../ecs/System.js';
import { StatusEffects } from '../components/index.js';
import { Events } from '../core/EventBus.js';

export class StatusEffectSystem extends System {
  static priority = 5;

  /**
   * @param {number} dt Delta time in seconds.
   * @returns {void}
   */
  update(dt) {
    for (const entity of this.world.query(StatusEffects)) {
      const effects = entity.get(StatusEffects);
      let changed = false;

      for (const [stat, effect] of effects.active) {
        effect.remaining -= dt;
        if (effect.remaining > 0) continue;
        effects.active.delete(stat);
        changed = true;
      }

      for (const [status, effect] of effects.timed) {
        effect.remaining -= dt;
        if (effect.remaining > 0) continue;
        effects.timed.delete(status);
        changed = true;
      }

      if (effects.shieldRemaining > 0) {
        effects.shieldRemaining -= dt;
        if (effects.shieldRemaining <= 0) {
          effects.shieldRemaining = 0;
          effects.shield = 0;
          changed = true;
        }
      }

      if (changed) this.ctx.events.emit(Events.STATUS_CHANGED, { effects });
    }
  }
}
